  <svg
    [style.max-height]="height"
    [style.min-height]="height"
    viewBox="0 0 66 91"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M33 2.5C24.9209 2.5 17.5096 3.93682 12.0432 6.34152C9.31277 7.54264 6.97809 9.02458 5.29837 10.7715C3.60916 12.5284 2.5 14.6493 2.5 17.0386L2.50001 85.5C2.50001 87.1569 3.84316 88.5 5.50001 88.5H60.5C62.1568 88.5 63.5 87.1569 63.5 85.5L63.5 17.0386C63.5 14.6495 62.3912 12.5286 60.7023 10.7717C59.0229 9.02467 56.6885 7.54269 53.9583 6.34155C48.4923 3.93681 41.0809 2.5 33 2.5Z"
      fill="url(#paint0_linear_1653_90685)"
      [attr.stroke]="tankVolumeChartBorderColor"
      stroke-width="6"
    />

    <path
      id="tankVolumePath"
      [attr.fill]="fillColor"
      [attr.d]="tankVolumePath()"
    />

    <path
      d="M33 2.5C24.9209 2.5 17.5096 3.93682 12.0432 6.34152C9.31277 7.54264 6.97809 9.02458 5.29837 10.7715C3.60916 12.5284 2.5 14.6493 2.5 17.0386L2.50001 85.5C2.50001 87.1569 3.84316 88.5 5.50001 88.5H60.5C62.1568 88.5 63.5 87.1569 63.5 85.5L63.5 17.0386C63.5 14.6495 62.3912 12.5286 60.7023 10.7717C59.0229 9.02467 56.6885 7.54269 53.9583 6.34155C48.4923 3.93681 41.0809 2.5 33 2.5Z"
      fill="transparent"
      [attr.stroke]="tankVolumeChartBorderColor"
      stroke-width="6"
    />

    <path
      d="M33 2.5C24.9209 2.5 17.5096 3.93682 12.0432 6.34152C9.31277 7.54264 6.97809 9.02458 5.29837 10.7715C3.60916 12.5284 2.5 14.6493 2.5 17.0386L2.50001 85.5C2.50001 87.1569 3.84316 88.5 5.50001 88.5H60.5C62.1568 88.5 63.5 87.1569 63.5 85.5L63.5 17.0386C63.5 14.6495 62.3912 12.5286 60.7023 10.7717C59.0229 9.02467 56.6885 7.54269 53.9583 6.34155C48.4923 3.93681 41.0809 2.5 33 2.5
  L0 0H100V100H-100V-100
  Z"
      fill="#F4F4F4"
      stroke="#F4F4F4"
      stroke-width="0"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1653_90685"
        x1="33"
        y1="88.2253"
        x2="33"
        y2="13.1959"
        gradientUnits="userSpaceOnUse"
      >
        <stop [attr.stop-color]="gradientDarkestColor" />
        <stop offset="1" [attr.stop-color]="gradientLightestColor" />
      </linearGradient>
    </defs>
  </svg>
